import React from 'react'
import Dialog from './Dialog'
import { ReactSVG } from 'react-svg'
import Btn from './Btn'
import BtnIcon from './BtnIcon'
import Card from './Card'
import IconTextBlock from '../components/IconTextBlock'
import SliderRating from './SliderRating'
import { useAxios } from '../hooks/useAxios'
import { toast } from 'react-toastify'
import addRating from '../api/addRating'

interface informationItem {
  icon: string
  text: string
}

interface IProps {
  informationItem: informationItem
  title: string
  id: string
  updateSuccessText?: string
}

const EventRating: React.FC<IProps> = ({
  informationItem,
  title,
  id,
  updateSuccessText = 'Успешно'
}) => {
  const [rating, setRating] = React.useState(3)
  const { fire, loading } = useAxios()

  const handleRatingChange = (newRating: number) => {
    setRating(newRating)
  }

  const load = async (): Promise<void> => {
    const { error } = await fire(addRating(id, rating))

    if (error) {
      toast.error(error.message)
    } else {
      toast.success(updateSuccessText)
    }
  }

  return (
    <div className={'event-rating'}>
      <Dialog
        className={'event-rating__popup-activator'}
        activator={(open) => (
          <Btn onClick={async () => await open()}>Оценить мероприятие</Btn>
        )}
        render={(close) => (
          <Card style={{ maxWidth: '55rem' }}>
            <header className="card-head _centered">
              <div className="card-head__title text-h3">
                Оцените мероприятие
              </div>
              <BtnIcon
                className={'card-head__control _right-side'}
                onClick={async () => await close()}
                filled
              >
                <ReactSVG src={'/i/svg/x.svg'} wrapper={'span'}></ReactSVG>
              </BtnIcon>
            </header>

            <div className="event-rating__text-wrapper">
              <h4 className="text-h4">{title}</h4>
              <IconTextBlock list={[informationItem]} />
            </div>

            <div className="event-rating__rating u-flex u-flexAlignItemsCenter ">
              <SliderRating
                rating={rating}
                onChange={handleRatingChange}
              ></SliderRating>
            </div>

            <footer className="u-flex u-flexJustifyCenter text-align-center">
              <Btn
                disabled={loading}
                loading={loading}
                onClick={async () => {
                  void close()
                  void load()
                }}
              >
                Отправить
              </Btn>
            </footer>
          </Card>
        )}
      ></Dialog>
    </div>
  )
}

export default EventRating
